import React, { useContext } from 'react'
import { Drawer } from 'antd'

import { RightActionBarContext } from '../../context/rightActionBarContext'
import { TAB_SIZE } from '@vacationtracker/shared/constants/sizes'

const RightActionBarDrawer = (): React.ReactElement => {
  const {
    activeDrawer,
    drawerContent,
    drawerWidth,
    closeDrawer,
  } = useContext(RightActionBarContext)

  const isOpen = !!activeDrawer

  // Calculate drawer width - responsive
  const getDrawerWidth = (): number => {
    const screenWidth = window.innerWidth

    if (screenWidth < TAB_SIZE) {
      // Mobile: full width minus some margin
      return Math.min(screenWidth - 32, 400)
    } else if (screenWidth < 1200) {
      // Tablet: 60% of screen width
      return Math.min(screenWidth * 0.6, drawerWidth || 450)
    } else {
      // Desktop: use specified width or default
      return drawerWidth || 450
    }
  }

  return (
    <Drawer
      title={null}
      placement="right"
      onClose={closeDrawer}
      open={isOpen}
      width={getDrawerWidth()}
      className="right-actionbar-drawer"
      destroyOnHidden={false}
      maskClosable={true}
      keyboard={true}
      closable={false}
      // Position drawer to not overlap with right navbar on desktop
      style={{
        marginRight: window.innerWidth >= TAB_SIZE ? '80px' : '0px',
      }}
      styles={{
        body: {
          padding: 0,
          height: '100%',
        },
      }}
    >
      <div className="right-actionbar-drawer-content">
        {drawerContent}
      </div>
    </Drawer>
  )
}

export default RightActionBarDrawer
